<template lang="html">
  <v-footer class="footer" padless app height="30px" :style="`${$route.matched[2] &&
    $route.matched[2].name === 'ProjectInviteWPSelectTaktPlan' ?
    'display: none' : ''};
  ${$route.matched[1] &&
      [
  'WorkBenchWorkPackageEditor',
  'WorkBenchSequenceEditor',
      ].includes($route.matched[1].name) ?
      'z-index: 0 !important' : ''};
  `">
    <button @click="changeTheme()"
      class="version-token t-rounded font-weight-light">{{ $t('AppLayout.Footer.He') }}</button>
    <div class="version-name font-weight-light">{{ $t('AppLayout.Footer.Helium') }}</div>
    <span class="version-number ml-1 font-weight-light">v{{ version_number }}</span>
    <span class="version-number ml-1 font-weight-light">- {{ app_version }}</span>
    <!-- <div class="ml-1 mr-1">-</div> -->

    <v-spacer></v-spacer>
    <span class="mr-2 font-weight-light">{{ timestamp }}</span>
    <v-spacer></v-spacer>

    <button @click="goToHelp()">
      <TIcon name="question-mark-circle" color="primary" />
    </button>

    <button v-if="$route.path.includes('/projects/')" class="footer-button-toggle" v-ripple
      @click="show_overlay = true">
      <TIcon name="display-settings" color="primary" />
    </button>


    <button v-if="hasPermission('Language CREATE')" class="footer-language-button footer-button-toggle"
      :style="`background-color: ${isEdit ? getColor('primary') : getColor('color-2')}`" v-ripple @click="switchEdit()">
      <TIcon name="speech-bubble" :color="`${!isEdit ? 'primary' : 'color-2'}`" small />
    </button>

    <!-- NOTE: LANGUAGE SELECTION (TRANSLATE) -->
    <button :class="`footer-language-button ${show_countries ? 'color-3' : ''}`" v-ripple v-click-outside="hideLanguage"
      @click="show_countries = !show_countries">
      <span :class="`fi fi-${getCurrentCountry.flag}`" />
      <div v-if="show_countries" :class="`footer-language-options ${show_countries ? 'color-3' : ''}`">
        <div v-for="country in getCountriesWithoutCurrent" :key="country.flag" class="footer-language-option"
          @click="changeLan(country.language)">
          <span :class="`fi fi-${country.flag}`" />
        </div>
      </div>
    </button>

    <!-- NOTE: Legal Notice -->
    <span class="mr-2 font-weight-light" style="cursor: pointer;" @click="goToLegalNotice()">
      {{ $t('AppLayout.Footer.LegalNotice') }}
    </span>

    <!-- NOTE: DISPLAY SETTINGS -->
    <!-- TODO: Move these to a more apropriate place! -->
    <PopUpOverlay v-if="show_overlay" class="footer-display-settings-popup" width="300px"
      position_css="top: -50vh; left: 50vw; transform: translate(-50%, -50%);" margin="16"
      @closeOverlay="show_overlay = false"
    >
      <template #head>
        <TText value="Display Settings" />
      </template>
      <template #body>
        <div class="footer-display-settings-popup-body">
          <div v-for="setting in getSettings" :key="`${setting.desc.toLowerCase()} setting`" class="footer-display-settings-popup-item">
            <ToggleCapsule :is_active="setting.value" knob_color="white" foreground_color="green"
              @toggleClicked="changeValue(setting.key, setting.desc, setting.localStorage)" />
            <TText :value="setting.desc" />
          </div>
        </div>
      </template>
    </PopUpOverlay>

  </v-footer>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import "/node_modules/flag-icons/css/flag-icons.min.css";
import TIcon from '@/components/Taktify/TIcon.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import PopUpOverlay from '@/components/WorkPackageWIP/PopUpOverlay.component.vue';
import ToggleCapsule from '@/components/WorkPackageWIP/ToggleCapsule.component.vue';
import { TColor } from '@/mixins/TColor.mixin.js';

export default {
  components: {
    TIcon,
    TText,
    PopUpOverlay,
    ToggleCapsule,
  },
  mixins: [
    TColor,
  ],
  data: () => ({
    version_number: '',
    timestamp: '',
    app_version: process.env.VUE_APP_VERSION,
    show_countries: false,
    toggle_language_edit: false,
    show_overlay: false,
  }),
  created() {
    let json = require('../../../package.json');
    this.version_number = json.version;
    setInterval(this.getNow, 1000);
  },
  computed: {
    ...mapGetters('Language', [
      'getCurrentLanguage',
      'getCurrentCountry',
      'getCountries',
      'isEdit'
    ]),
    ...mapGetters('Auth', [
      'hasPermission'
    ]),
    getCountriesWithoutCurrent() {
      let ret = [];
      let countries = this.getCountries;
      for (let i = 0; i < countries.length; i++) {
        if (countries[i].language !== this.getCurrentLanguage) {
          ret.push(countries[i]);
        }
      }
      return ret;
    },
    getSettings() {
      let settings = [
            {
              desc: 'Light Theme',
              localStorage: 'Light_Theme',
              value: !this.$vuetify.theme.dark,
              key: 'theme',
            },
            {
              desc: 'Taktplan Grid Column',
              localStorage: 'Taktplan_Grid_Column',
              value: this.$store.state.View.is_taktplan_grid_column,
              key: 'is_taktplan_grid_column',
            },
            {
              desc: 'Taktplan Grid Row',
              localStorage: 'Taktplan_Grid_Row',
              value: this.$store.state.View.is_taktplan_grid_row,
              key: 'is_taktplan_grid_row',
            },
            {
              desc: 'Takt Time Highlight',
              localStorage: 'Takt_Time_Highlight',
              value: this.$store.state.View.is_taktplan_takttime_highlight,
              key: 'is_taktplan_takttime_highlight',
            },
            {
              desc: 'Milestone Highlight',
              localStorage: 'Milestone_Highlight',
              value: this.$store.state.View.is_taktplan_milestone_highlight,
              key: 'is_taktplan_milestone_highlight',
            },
            {
              desc: 'Train Seperator',
              localStorage: 'Train_Seperator',
              value: this.$store.state.View.is_taktplan_train_seperator,
              key: 'is_taktplan_train_seperator',
            },
            {
              desc: 'Taktplan Legend',
              localStorage: 'Taktplan_Legend',
              value: this.$store.state.View.is_taktplan_legend,
              key: 'is_taktplan_legend',
            },
            {
              desc: 'Taktplan Legend Left',
              localStorage: 'Taktplan_Legend_Left',
              value: this.$store.state.View.is_taktplan_legend_left,
              key: 'is_taktplan_legend_left',
            },
            {
              desc: 'Taktplan Legend Left Rotated',
              localStorage: 'Taktplan_Legend_Left_Rotated',
              value: this.$store.state.View.is_taktplan_legend_left_rotated,
              key: 'is_taktplan_legend_left_rotated',
            },
            {
              desc: 'Taktplan Legend Milestones',
              localStorage: 'Is_Taktplan_Legend_Milestones',
              value: this.$store.state.View.is_taktplan_legend_milestones,
              key: 'is_taktplan_legend_milestones',
            },
            {
              desc: 'Taktplan Legend show only filtered Workpackages',
              localStorage: 'Is_Taktplan_Show_onlyFiltered_Workpackage',
              value: this.$store.state.View.is_taktplan_show_only_filtered_workpackages,
              key: 'is_taktplan_show_only_filtered_workpackages',
            },
            {
              desc: 'Taktplan Taktarea Description',
              localStorage: 'Taktplan_Taktarea_Description',
              value: this.$store.state.View.is_taktplan_taktarea_description,
              key: 'is_taktplan_taktarea_description',
            },
            {
                desc: 'Show Shadows in Taktplan',
                localStorage: 'Taktplan_Shadows',
                value: this.$store.state.View.show_taktplan_shadows,
                key: 'show_taktplan_shadows',
            },
            {
                desc: 'Use Intersection Observers',
                localStorage: 'Taktplan_Intersection_Observer',
                value: this.$store.state.View.use_intersection_observer,
                key: 'use_intersection_observer',
            },
            {
                desc: 'Show Taktplan',
                localStorage: 'Show_Taktplan',
                value: this.$store.state.View.show_taktplan,
                key: 'show_taktplan',
            },
          ];

          if (new Date().getMonth() === 11) {
            settings.push({
              desc: 'Let it Snow!',
              localStorage: 'Taktplan_Show_Snowflakes',
              value: this.$store.state.View.show_snowflakes,
              key: 'show_snowflakes',
            });
          }
     return settings;
    }
  },
  methods: {
    ...mapActions('Language', [
      'switchEdit',
      'changeLanguage'
    ]),
    ...mapActions('View', [
      'setValue',
    ]),
    changeLan(language) {
      this.changeLanguage(language);
      this.$i18n.locale = language;
      localStorage.setItem('TAKT_language', language);
    },
    goToLegalNotice() {
      this.$router.push({
        name: 'LegalNotice',
        params: this.$route.params,
        query: {
          redirect: this.$route.name
        }
      });
    },
    goToHelp(){
      this.$router.push({
        name: 'FAQ',
        params: this.$route.params,
        query: {
          redirect: this.$route.name
        }
      });
    },
    getNow() {
      const today = new Date();
      const day = today.getDate() < 10 ? '0' + today.getDate() : today.getDate();
      const month = (today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1);
      const year = today.getFullYear();
      let minute = today.getMinutes();
      if (minute < 10) {
        minute = '0' + minute.toString();
      }
      const time = today.getHours() + ':' + minute;
      const dateTime = day + '.' + month + '.' + year + ' ' + time;
      this.timestamp = dateTime;
    },
    changeTheme() {
      localStorage.setItem('TAKT_theme', !this.$vuetify.theme.dark);
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    },
    changeValue(variable, desc, storageKey) {
      // NOTE: is handled in $vuetify
      if (variable === 'theme') {
        this.changeTheme();
      }
      // NOTE: everything elese is handled in $store.state.View
      else {
        // cookie strings are: 'Taktplan_Grid', 'Takt_Time_Highlight', 'Train_Seperator', 'Taktplan_Legend'
        localStorage.setItem(storageKey, !this.$store.state.View[variable]);
        this.setValue({ key: variable, value: !this.$store.state.View[variable] });
      }
    },
    hideLanguage() {
      this.show_countries = false;
    }
  }
}
</script>
<style scoped>
.footer {
  padding: 0px;
  justify-content: center !important;
  align-items: center !important;  
  z-index: 999999;
}

.version-number {
  font-size: 16px;
}

.version-token {
  display: flex;
  height: 20px;
  width: 20px;
  border: solid 1px var(--v-primary-base);
  justify-content: center;
  align-items: center;
  font-size: 12px;
  margin-right: 2px;
}

.version-name {
  font-size: 16px;
}

.footer-language-option {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
}

.footer-language-option:hover {
  background-color: #FFF4;
}

.footer-language-options {
  width: 50px;
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 100%;
  z-index: -1;
}

.footer-language-button {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 50px;
  margin-right: 8px;
}

.footer-button-toggle {
  width: 30px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.footer-display-settings-popup {
  border: 1px solid grey;
}

.footer-display-settings-popup-body {
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
  padding: 8px 0;
}

.footer-display-settings-popup-item {
  display: flex;
  grid-gap: 16px;
}
</style>
